export default __webpack_public_path__ + "static/media/boxbg2.8bd6f6a0.jpeg";